import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["projectNameField", "projectNameInput"]

  connect() {
    this._emailStarted = false
    this.updateProjectNameVisibility()
    this.capture("waitlist_modal_viewed")
  }

  updateProjectNameVisibility() {
    const interest = this.element.querySelector("input[name='waiting_list_signup[interest]']:checked")?.value
    const show = interest === "dev" || interest === "both"

    this.projectNameFieldTarget.hidden = !show
    this.projectNameInputTarget.required = show
    if (!show) this.projectNameInputTarget.value = ""
  }

  emailInput(event) {
    if (this._emailStarted) return
    if (!event?.target?.value?.trim()) return
    this._emailStarted = true
    this.capture("waitlist_modal_email_started")
  }

  capture(event, properties = {}) {
    if (typeof window === "undefined") return
    if (!window.posthog || typeof window.posthog.capture !== "function") return
    window.posthog.capture(event, properties)
  }
}
